// extracted by mini-css-extract-plugin
module.exports = {"prices":"_3uack","outOfStock":"_3DJ-f","priceBeforeDiscount":"_23IPr","priceFrom":"_1oUu4","priceToPay":"_23ArP","basePrice":"a-Gyw"};